// src/components/RotaProtegida.jsx
// ─────────────────────────────────────────────────────────
// Envolve qualquer página que precisa de login.
// Se o usuário não estiver autenticado → redireciona para /login
// Se não tiver o perfil necessário → mostra "sem permissão"
// ─────────────────────────────────────────────────────────

import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RotaProtegida({ children, perfisPermitidos }) {
  const { usuario } = useAuth();

  // Não logado → vai para o login
  if (!usuario) {
    return <Navigate to="/login" replace />;
  }

  // Perfil sem permissão para essa rota específica
  if (perfisPermitidos && !perfisPermitidos.includes(usuario.perfil)) {
    return (
      <div style={styles.semPermissao}>
        <div style={styles.icon}>🔒</div>
        <h2 style={styles.titulo}>Acesso restrito</h2>
        <p style={styles.desc}>
          Seu perfil <strong>{usuario.perfil}</strong> não tem permissão para acessar esta área.
        </p>
      </div>
    );
  }

  return children;
}

const styles = {
  semPermissao: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '40px',
    textAlign: 'center',
    fontFamily: "'Poppins', sans-serif",
  },
  icon:   { fontSize: '48px', marginBottom: '16px', opacity: 0.3 },
  titulo: { fontSize: '18px', color: '#3F0051', marginBottom: '8px', fontFamily: "'Playfair Display', serif" },
  desc:   { fontSize: '13px', color: '#6b7280', lineHeight: 1.6 },
};
